module.exports = __webpack_public_path__ + "static/media/Naghma-Mulla.e64a495b.jpg";